import React from "react";
import {components} from "react-select";
import {ChevronDown} from "assets/icons";

// Shared look of the react-select fields (MonoSelect, MultiDdl): the box of the text fields
// (StyledInput: gray-200 border, orange when focused) and the menu and chevron of the search type
// select of the lists (components/search/SearchBar): a shadowed menu, plain gray options.
export const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '40px',
        height: '40px',
        backgroundColor: '#FFFFFF',
        // Same border as the text fields (StyledInput): gray-200, orange when focused.
        borderColor: state.isFocused ? '#FF9600' : '#E5E7EB',
        borderWidth: '1px',
        borderRadius: '0.4rem',
        boxShadow: 'none',
        cursor: 'pointer',
        '&:hover': {
            borderColor: state.isFocused ? '#FF9600' : '#E5E7EB',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '0 16px',
        height: '40px',
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
        fontSize: '0.875rem',
        color: '#374151',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#9CA3AF',
        fontSize: '0.875rem',
    }),
    singleValue: (base) => ({
        ...base,
        color: '#374151',
        fontSize: '0.875rem',
    }),
    // Only used by the selects rendered in a portal (MultiDdl, MonoSelect): above the fixed footers (z-20),
    // the modals (z-40/z-50) and the floating menus of the app (z-[9999]).
    menuPortal: (base) => ({
        ...base,
        zIndex: 10000,
    }),
    menu: (base) => ({
        ...base,
        marginTop: '4px',
        overflow: 'hidden',
        borderRadius: '0.375rem',
        border: '1px solid #E5E7EB',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
    }),
    menuList: (base) => ({
        ...base,
        padding: 0,
    }),
    option: (base, state) => ({
        ...base,
        padding: '8px 16px',
        fontSize: '0.875rem',
        cursor: 'pointer',
        color: state.isSelected ? '#111827' : '#374151',
        backgroundColor: state.isFocused ? '#F3F4F6' : state.isSelected ? '#FCFCFC' : '#FFFFFF',
        '&:active': {
            backgroundColor: '#F3F4F6',
        },
    }),
    noOptionsMessage: (base) => ({
        ...base,
        fontSize: '0.875rem',
        color: '#6B7280',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#374151',
        padding: '0 12px 0 4px',
        '&:hover': {
            color: '#111827',
        },
    }),
};

// The chevron of the SearchBar select, in place of react-select's own.
export const SelectDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <ChevronDown wh={16} color="#374151" />
    </components.DropdownIndicator>
);
